module.exports = __webpack_public_path__ + "static/media/markasread.e044e79d.gif";